var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25.604,
    viewBox: "0 0 25 25.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p1ig491moa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H25V25.604H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p1ig491moa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1291d9",
    d: "M0 25.6v-3.2C0 18.882 5.625 16 12.5 16S25 18.882 25 22.4v3.2zM6.249 6.4A6.327 6.327 0 0 1 12.5 0a6.327 6.327 0 0 1 6.249 6.4 6.327 6.327 0 0 1-6.249 6.4 6.327 6.327 0 0 1-6.251-6.4z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlue);
export default __webpack_public_path__ + "static/media/profile_blue.b8624fe7.svg";
export { ForwardRef as ReactComponent };